import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {Platform} from "@angular/cdk/platform";

@Component({
  selector: 'lib-no-media-permissions',
  templateUrl: './no-media-permissions.component.html',
  styleUrls: ['./no-media-permissions.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoMediaPermissionsComponent {
  constructor(public platform: Platform) {
  }
}
